export default "__VITE_ASSET__CSuIig0M__";